import { setupFormState } from '@/components/form/tidal-form'
import type { RmAccountFormValues } from '../types'

export const initialValues: RmAccountFormValues = {
  email: '',
  name: '',
  surname: '',
  username: '',
}

export const form = setupFormState<RmAccountFormValues>({
  id: 'rm-account-form',
  initialValues,
})
